import { DefaultSkillMapTarget } from '../../_generated/graphql'
import type { UserInfo } from '../services/user/user.service'
import { isFeatureAllowed } from './feature-permission.config'

export function getVisibleAssessmentSettingSections(
  enabledFeatures: string[] | undefined,
): DefaultSkillMapTarget[] {
  return isFeatureAllowed('MEETING_RECORDING', enabledFeatures)
    ? [DefaultSkillMapTarget.MeetingRecording]
    : []
}

export function isAssessmentSettingsPageVisible(
  user: Pick<UserInfo, 'enabledFeatures' | 'roles'>,
): boolean {
  return (
    getVisibleAssessmentSettingSections(user.enabledFeatures).length > 0 ||
    user.roles.some((role) => role.code === 'SUPER_ADMIN')
  )
}

export const ASSESSMENT_SETTING_SECTION_LABELS: Record<
  DefaultSkillMapTarget,
  string
> = {
  MEETING_RECORDING: '商談録音',
  FILE_UPLOAD: 'ファイルアップロード',
  BULK_EXECUTION: '一括実行',
}

export const ASSESSMENT_SETTING_SECTION_DESCRIPTIONS: Record<
  DefaultSkillMapTarget,
  string
> = {
  MEETING_RECORDING:
    '商談録音を開いたときに最初に選択されるスキルマップです。ファイルアップロードや AI ロープレには影響しません。',
  FILE_UPLOAD: 'ファイルアップロードで最初に選択されるスキルマップです。',
  BULK_EXECUTION: 'アセスメント一括実行で最初に選択されるスキルマップです。',
}
